import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Trash2 } from "lucide-react";

export default function AdminClients() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/clients").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Supprimer ce client (RGPD) ?")) return;
    try { await api.delete(`/admin/clients/${id}`); toast.success("Supprimé"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <div data-testid="admin-clients">
      <h1 className="font-display font-black text-3xl mb-8">Clients</h1>
      <div className="card-dark overflow-x-auto">
        {items.length === 0 ? <div className="p-10 text-center text-slate-500 text-sm">Aucun client.</div> : (
          <table className="w-full text-sm">
            <thead className="text-left text-slate-500 border-b border-white/10">
              <tr><th className="p-4">Nom</th><th className="p-4">Email</th><th className="p-4">Téléphone</th><th className="p-4">Réservations</th><th className="p-4">Total payé</th><th className="p-4"></th></tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-b border-white/5">
                  <td className="p-4">{c.first_name} {c.last_name}</td>
                  <td className="p-4 text-slate-400">{c.email}</td>
                  <td className="p-4 text-slate-400">{c.phone}</td>
                  <td className="p-4">{c.reservations_count}</td>
                  <td className="p-4 text-gold">{c.total_paid?.toFixed(2)} €</td>
                  <td className="p-4 text-right"><button onClick={() => remove(c.id)} className="text-slate-400 hover:text-red-400 p-1.5"><Trash2 size={16} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
